webpackJsonp([137408898365125],{

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team-header-big.b6694a01.jpg";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/team-header-small.9b11f08e.jpg";

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TeamCard = exports.TeamDescription = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin:1em auto;padding:1rem 1.5rem;& h2{color:inherit;margin:1.25rem 0;}');
	
	var cardNormal = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';background-color:white;');
	
	var cardInverted = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';background-color:', _colors2.default.black, ';');
	
	var teamStyle = /*#__PURE__*/(0, _reactEmotion.css)(cardStyle, ';padding:0;margin:0;margin-top:2rem;background-color:', _colors2.default.black, ';& img{width:100%;margin:0;}');
	
	var TeamDescription = /*#__PURE__*/exports.TeamDescription = (0, _reactEmotion2.default)('div', {
	  target: 'css-62tymv0'
	})('width:100%;height:auto;padding:0.5rem 0.5rem;& h2{margin:0;}& p{margin-top:1rem;}& ul{margin:0;display:flex;list-style-type:none;}& ul li{margin:0;margin-left:0.5rem;}& ul li:first-child{margin:0;}');
	
	var TeamCard = exports.TeamCard = function TeamCard(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: teamStyle },
	    children
	  );
	};
	
	exports.default = function (_ref2) {
	  var inverted = _ref2.inverted,
	      children = _ref2.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: inverted ? cardInverted : cardNormal },
	    children
	  );
	};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _teamHeaderBig = __webpack_require__(112);
	
	var _teamHeaderBig2 = _interopRequireDefault(_teamHeaderBig);
	
	var _teamHeaderSmall = __webpack_require__(113);
	
	var _teamHeaderSmall2 = _interopRequireDefault(_teamHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _Cards = __webpack_require__(37);
	
	var _feather = __webpack_require__(39);
	
	var _feather2 = _interopRequireDefault(_feather);
	
	var _SEO = __webpack_require__(26);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var team = data.allTeamJson.edges;
	
	  var myTitle = 'Experts in Data Networks, Structured Cabling, and Fiber Optics | PCS';
	  var myDesc = 'PCS team has decades of low voltage wiring and data network design between them. PCS is your one stop shop for all thing data.';
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_SEO2.default, { title: myTitle,
	      description: myDesc
	    }),
	    _react2.default.createElement(
	      _Hero2.default,
	      { imageBig: _teamHeaderBig2.default, imageSmall: _teamHeaderSmall2.default },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: "white", p: [3, 3, 3], align: "left" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Team"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { color: "white", p: [2, 2, 2], align: "left" },
	      _react2.default.createElement(
	        _Layout.Flex,
	        { wrap: ["wrap", "wrap", "wrap"], justify: "space-between" },
	        team.map(function (_ref2) {
	          var item = _ref2.node;
	
	          return _react2.default.createElement(
	            _Layout.Box,
	            { key: item.id, color: "white", width: [1, 1, "20%"] },
	            _react2.default.createElement(
	              _Cards.TeamCard,
	              null,
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("img", {
	                  src: item.avatar.children[0].responsiveResolution.src,
	                  srcSet: item.avatar.children[0].responsiveResolution.srcSet,
	                  alt: "Picture of " + item.name
	                })
	              ),
	              _react2.default.createElement(
	                _Cards.TeamDescription,
	                null,
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  item.name
	                ),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement(
	                    "em",
	                    null,
	                    item.position
	                  )
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  item.description
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "mailto:" + item.email },
	                      (0, _feather2.default)("mail", ["20", "20"])
	                    )
	                  )
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-team-js-767a405a198416498775.js